<template>
	<div>
		<header class="sticky top-0 z-20">
			<div class="bg-white shadow py-4 relative z-10">
				<div class="container mx-auto px-4 flex items-center text-xl uppercase text-gray-700 flex-col sm:flex-row sm:justify-between sm:items-center md:px-8 lg:text-lg xl:text-xl">
					<img class="h-6 mx-auto sm:h-8 sm:mx-0 lg:h-10" :src="require('@/assets/tailgating/logo.svg')">
					<a class="mt-4 text-dish-red font-bold leading-none sm:mt-0 sm:text-3xl lg:text-4xl" :href="phoneUrl">{{ phoneNumber }}</a>
				</div>
			</div>
		</header>

		<aside class="container mx-auto shadow bg-dish-red text-white leading-tight sm:bg-white sm:text-dish-red sm:my-4 lg:max-w-5xl" v-if="offerActive">
			<div class="py-4 px-4 text-center sm:hidden">
				<p class="uppercase text-2xl font-bold leading-tight">Win a prize pack worth $2,000</p>
				<div class="flex">
					<a class="mx-auto font-bold block mt-2 text-dish-red bg-white py-1 px-4 rounded-full" href="/rvready">Enter Now</a>
				</div>
			</div>
			<div class="hidden justify-center items-center sm:flex">
				<div class="w-2/5 bg-cover bg-no-repeat bg-center py-1 md:w-1/2 lg:w-3/5" style="background-image: url('/rvready/header/sm.jpg')">
					<img class="mx-auto h-40" :src="require('@/assets/rvready/Graphics/Badge.svg')">
				</div>
				<div class="w-3/5 py-2 px-4 text-center md:w-1/2 lg:w-2/5 lg:px-8">
					<p class="uppercase text-3xl font-bold leading-tight">Win a prize pack worth $2,000</p>
					<div class="flex">
						<a class="mx-auto font-bold block mt-2 text-white bg-dish-red py-1 px-4 rounded-full text-xl" href="/rvready">Enter Now</a>
					</div>
				</div>
			</div>
		</aside>

		<main class="container mx-auto shadow bg-white">
			<section class="relative text-white px-4 py-8 bg-cover text-center lg:px-8 lg:py-24 lg:overflow-hidden lg:bg-right lg:text-left xl:px-16 xl:py-28" :style="`background-image: url(${require('@/assets/tailgating/bg.jpg')}); background-position: center top;`">
				<div class="hidden absolute bg-contain bg-no-repeat bg-right w-full h-full bottom-0 right-0 lg:block" :style="`background-image: url(${require('@/assets/tailgating/desktop-eyecatcher.png')})`"></div>
				<div class="relative z-10">
					<h2 class="text-3xl leading-none font-bold mx-auto sm:text-4xl sm:max-w-lg md:max-w-full lg:max-w-xl lg:ml-0 lg:text-6xl lg:font-semibold xl:max-w-3xl xl:text-7xl">Make DISH Outdoors Your Game Day MVP</h2>
					<p class="text-xl leading-tight mt-2 sm:text-2xl md:max-w-xl md:mx-auto lg:ml-0 lg:mt-4 lg:text-2xl xl:text-3xl xl:max-w-2xl">Pay As You Go programming lets you only pay for the months you use - perfect for football season!</p>
					<div class="-mx-4 -mb-24 mt-8 lg:hidden">
						<img class="mx-auto" :src="require('@/assets/tailgating/Mobile-Circle-Header.png')">
					</div>
				</div>
			</section>

			<section class="pt-16 lg:pt-0"></section>

			<section class="px-4 py-8 relative text-center">
				<div class="relative">
					<div class="absolute top-0 -mt-16" id="offer"></div>
				</div>
				<div class="leading-none text-center md:hidden">
					<p class="text-3xl sm:text-4xl xl:text-5xl">Act Now And Get</p>
					<p class="price text-7xl text-dish-red font-bold">30 Off</p>
					<p class="text-xl sm:text-4xl xl:text-5xl">Any Satellite Antenna Bundle</p>
				</div>

				<div class="flex flex-col md:flex-row md:items-center">
					<div class="mt-4 md:w-1/2 md:mr-2">
						<img class="mx-auto max-w-xs w-full sm:max-w-md md:max-w-full" :src="require('@/assets/trucking/bundle.png')">
					</div>
					<div class="mt-4 mx-auto w-full max-w-sm sm:max-w-full md:w-1/2 md:ml-2">
						<div class="leading-none text-center hidden mb-8 md:block">
							<p class="text-3xl sm:text-4xl xl:text-5xl">Act Now And Get</p>
							<p class="price text-7xl text-dish-red font-bold">30 Off</p>
							<p class="text-xl sm:text-4xl xl:text-5xl">Any Satellite Antenna Bundle</p>
						</div>

						<div class="text-center border-4 border-dashed border-black py-2 px-4">
							<p class="leading-tight sm:text-xl">Use Code At Checkout: <span class="block font-bold text-2xl text-dish-red tracking-wide sm:text-4xl">TAILGATING30</span></p>
						</div>

						<div class="text-center mt-4">
							<a href="https://www.dishformyrv.com/bundles/" class="font-bold text-white bg-dish-red py-1 px-3 inline-block mx-auto mt-2 rounded text-xl lg:text-2xl lg:mt-4">Shop Now</a>
						</div>
					</div>
				</div>
			</section>

			<div class="h-px bg-gray-400 mx-4"></div>

			<section class="px-4 py-8 text-center relative lg:hidden">
				<h2 class="text-3xl font-semibold leading-none sm:text-4xl xl:text-5xl">Choose Your Antenna</h2>
				<flickity ref="antennas" class="antennas-flickity -mx-4 mt-4 lg:flex" :options="flickityOptions">
					<div class="w-2/3 pb-4 px-2 max-w-xs min-h-full sm:w-5/12 lg:pb-0 lg:flex-grow lg:px-0" v-for="(antenna, index) in antennas" :key="index">
						<div class="pb-2 h-full lg:shadow-none">
							<img @load="$refs['antennas'].resize()" class="mx-auto lg:w-3/4" :src="antenna.img">
							<div class="px-4 pb-2 mt-4 flex flex-col leading-none" :class="index == 0 ? '' : 'lg:border-l-2 border-gray-700'">
								<h4 class="font-bold text-xl xl:text-2xl">{{ antenna.name }}</h4>
								<p class="text-gray-700 text-lg mt-1 line-through invisible">$119</p>
								<p class="price text-dish-red text-5xl xl:text-6xl">{{ antenna.price }}</p>
							</div>
						</div>
					</div>
				</flickity>
				<h2 class="text-3xl font-semibold leading-none sm:text-4xl xl:text-5xl">Then Add The Wally</h2>
				<div class="w-2/3 mt-4 mx-auto px-2 max-w-xs min-h-full sm:w-5/12 lg:pb-0 lg:flex-grow lg:px-0">
					<div class="h-full lg:shadow-none">
						<img class="mx-auto lg:w-3/4" :src="require('@/assets/tailgating/Wally.png')">
						<div class="px-4 pb-2 mt-4 flex flex-col leading-none">
							<h4 class="font-bold text-xl xl:text-2xl">DISH Wally</h4>
							<p class="text-gray-700 text-lg mt-1 line-through">$119</p>
							<p class="price text-dish-red text-5xl xl:text-6xl">99</p>
						</div>
					</div>
				</div>

				<a href="https://www.dishformyrv.com/satellite-antennas/?st-t=dishenth" class="font-bold text-white bg-dish-red py-1 px-3 inline-block mx-auto mt-2 rounded text-xl lg:text-2xl lg:mt-4">Shop Now</a>
			</section>

			<section class="px-4 py-8 text-center relative hidden lg:block">
				<h2 class="text-3xl font-semibold leading-none sm:text-4xl xl:text-5xl">Choose Your Antenna Then Add The Wally</h2>
				<div class="antennas-flickity -mx-4 mt-4 lg:flex">
					<div class="w-2/3 pb-4 px-2 max-w-xs min-h-full sm:w-5/12 lg:pb-0 lg:flex-grow lg:px-0" v-for="(antenna, index) in antennas" :key="index">
						<div class="pb-2 h-full flex flex-col shadow-none">
							<a href="https://www.dishformyrv.com/satellite-antennas/?st-t=dishenth">
								<img class="mx-auto w-3/4 mt-auto" :src="antenna.img">
							</a>
							<div class="px-4 pb-2 mt-4 flex flex-col leading-none">
								<h4 class="font-bold text-xl xl:text-2xl">{{ antenna.name }}</h4>
								<p class="text-gray-700 text-lg mt-1 line-through invisible">$119</p>
								<p class="price text-dish-red text-5xl xl:text-6xl">{{ antenna.price }}</p>
							</div>
						</div>
					</div>
					<div class="w-2/3 mt-4 mx-auto px-2 max-w-xs min-h-full sm:w-5/12 lg:pb-0 lg:flex-grow lg:px-0">
						<div class="pb-2 h-full flex flex-col justify-end shadow-none">
							<a class="mx-auto w-3/4" style="min-height: 1px;" href="https://www.dishformyrv.com/satellite-antennas/?st-t=dishenth">						
								<img class="w-full" :src="require('@/assets/Wally.png')">
							</a>
							<div class="px-4 pb-2 mt-4 flex flex-col leading-none">
								<h4 class="font-bold text-xl xl:text-2xl">DISH Wally</h4>
								<p class="text-gray-700 text-lg mt-1 line-through">$119</p>
								<p class="price text-dish-red text-5xl xl:text-6xl">99</p>
							</div>
						</div>
					</div>
				</div>

				<a href="https://www.dishformyrv.com/satellite-antennas/?st-t=dishenth" class="font-bold text-white bg-dish-red py-1 px-3 inline-block mx-auto mt-2 rounded text-xl lg:text-2xl lg:mt-4">Shop Now</a>
			</section>

			<div class="h-px bg-gray-400 mx-4"></div>

			<section class="py-8 px-4 text-center md:px-8 relative">
				<h2 class="text-3xl font-semibold leading-none sm:text-4xl xl:text-5xl">Flexible HD TV Programming</h2>
				<p class="mt-2 text-xl leading-tight text-left xl:max-w-4xl xl:mx-auto">We understand seasonality! Get 50+ channels for 30 days at a time starting at only $42.99, create your own package or save with America's Top Packages. Sports Fans LOVE the Multi-Sport-Pack add-on for only $13 a month so they always get all of their regional and nationwide teams!</p>

				<div class="mt-8 -mx-4 md:-mx-8 lg:px-8">
					<channel-boxes/>
				</div>

				<button class="bg-dish-red text-white py-2 px-6 rounded mt-4 font-semibold sm:text-xl xl:mt-8" @click="sportsModalOpen = true">Check Out Our Sports Channels</button>
				<transition enter-class="opacity-0" leave-to-class="opacity-0">
					<div v-if="sportsModalOpen" class="transitions z-50 fixed h-screen w-screen inset-0 flex justify-center items-center py-8 px-4">
						<div class="bg-black opacity-75 absolute inset-0" @click="sportsModalOpen = false"></div>
						<div class="relative z-10 w-full max-h-screen overflow-y-scroll max-w-6xl">
							<div class="bg-white pb-6 shadow rounded flex flex-wrap justify-center relative">
								<div @click="sportsModalOpen = false" class="absolute top-0 right-0 text-gray-700 hover:text-dish-red p-1 cursor-pointer">
									<svg viewBox="0 0 24 24" class="h-6 w-6" stroke="currentColor" stroke-width="2" fill="none" stroke-linecap="round" stroke-linejoin="round"><line x1="18" y1="6" x2="6" y2="18"></line><line x1="6" y1="6" x2="18" y2="18"></line></svg>
								</div>

								<div class="px-2 w-48 mt-6" v-for="channel in sportsChannels" :key="channel.name">
									<img class="h-12 w-auto mx-auto" :src="channel.img">
									<p class="leading-tight">{{ channel.name }}</p>
								</div>
							</div>
						</div>
					</div>
				</transition>
			</section>

			<div class="h-px bg-gray-400 mx-4"></div>

			<section class="py-8 px-4 text-center md:px-8 relative">
				<h2 class="text-3xl font-semibold leading-none sm:text-4xl xl:text-5xl">How To Take DISH Outdoors To Your Tailgate</h2>

				<hubspot-form formId="cb672c0b-607e-4e90-b1a7-f30d2ab308e0">
					<div class="flex flex-col items-center md:flex-row" slot-scope="{ submitting, submitted, submit, error }">
						<div class="mt-4 md:w-1/2 md:mr-2">
							<img :src="require('@/assets/tailgating/Form.jpg')">
						</div>
						<div class="mt-4 mx-auto max-w-sm sm:max-w-full md:w-1/2 md:ml-2">
							<template v-if="submitted">
								<p class="text-2xl text-center font-semibold">You will receive your Tailgating Antenna Guide Shortly!</p>
							</template>
							<template v-else>
								<h4 class="text-xl leading-none font-semibold lg:text-2xl">Enter Your Email To Get The Tailgating Antenna Guide</h4>

								<div class="sm:hidden md:block lg:mx-auto lg:max-w-sm">
									<input v-model="guideForm.email" type="email" placeholder="Email" class="mt-1 border shadow-inner py-3 px-2 w-full xl:mt-4">
									<p class="text-dish-red font-bold mt-1 mb-2" v-if="guideForm.invalidEmail">Invalid Email</p>
									<button @click="submitForm(submit)" :class="{ submitting }" class="bg-dish-red py-1 px-3 font-semibold text-white w-full text-center mt-1 rounded xl:text-xl xl:mt-2">Download Our Tailgating Guide</button>
									<p class="text-dish-red font-bold mt-1 mb-2" v-if="error">There was an issue submitting. Please try again later.</p>
								</div>

								<div class="hidden sm:block md:hidden">
									<div class="flex flex-row mt-2 justify-center">
										<input v-model="guideForm.email" type="email" placeholder="Email" class="mt-1 border shadow-inner py-3 px-2 w-full sm:w-64 sm:py-1 sm:rounded-r-none sm:rounded-l xl:py-3">
										<button @click="submitForm(submit)" :class="{ submitting }" class="bg-dish-red py-1 px-3 font-semibold text-white w-full text-center mt-1 rounded sm:w-auto sm:flex-shrink-0 sm:rounded-l-none xl:py-3">Download Our Tailgating Guide</button>
									</div>
									<p class="text-dish-red font-bold mt-1" v-if="guideForm.invalidEmail">Invalid Email</p>
									<p class="text-dish-red font-bold mt-1 mb-2" v-if="error">There was an issue submitting. Please try again later.</p>
								</div>
							</template>
						</div>
					</div>
				</hubspot-form>
			</section>

			<section class="bg-dish-red py-4">
				<img class="h-8 w-auto mx-auto" :src="require('@/assets/dish-outdoors-white.svg')">
			</section>
		</main>
	</div>
</template>

<script>
	import ChannelBoxes from 'channel-boxes'
	import Flickity from 'vue-flickity'
	import objectFitImages from 'object-fit-images'

	import HubspotForm from '@/components/HubspotForm'

	const emailRegex = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
	
	export default {
		components: {
			ChannelBoxes,
			Flickity,
			HubspotForm,
		},

		computed: {
			phoneUrl() {
				return `tel:${this.phoneNumber}`
			},
		},

		data() {
			return {
				antennas: [
					{ img: require('@/assets/common/Playmaker.png'), name: 'DISH Playmaker®', price: 249 },
					{ img: require('@/assets/common/Tailgater.png'), name: 'DISH Tailgater® 4', price: 299 },
					{ img: require('@/assets/common/Tailgater-Pro.png'), name: 'DISH Tailgater® Pro', price: 349 },
				],

				sportsModalOpen: false,
				sportsChannels: [{
					"img": "https://sc.dish.com/shared/images/station-logos/nflrz.png",
					"name": "NFL RedZone from NFL Network",
				}, {
					"img": "https://sc.dish.com/shared/images/station-logos/nfl.png",
					"name": "NFL Network",
				}, {
					"img": "https://sc.dish.com/shared/images/station-logos/nbatv.png",
					"name": "NBA TV",
				}, {
					"img": "https://sc.dish.com/shared/images/station-logos/nhln.png",
					"name": "NHL Network",
				}, {
					"img": "https://sc.dish.com/shared/images/station-logos/mlbn.png",
					"name": "MLB Network",
				}, {
					"img": "https://sc.dish.com/shared/images/station-logos/mlbsz.png",
					"name": "MLB Strike Zone",
				}, {
					"img": "https://sc.dish.com/shared/images/station-logos/pac12.png",
					"name": "Pac-12 Network",
				}, {
					"img": "https://sc.dish.com/shared/images/station-logos/lhn.png",
					"name": "Longhorn Network",
				}, {
					"img": "https://sc.dish.com/shared/images/station-logos/sec.png",
					"name": "SEC Network",
				}, {
					"img": "https://sc.dish.com/shared/images/station-logos/bein.png",
					"name": "beIN Sports",
				}, {
					"img": "https://sc.dish.com/shared/images/station-logos/beine.png",
					"name": "beIN Sports en español",
				}, {
					"img": "https://sc.dish.com/shared/images/station-logos/espngl.png",
					"name": "ESPN Goal Line",
				}, {
					"img": "https://sc.dish.com/shared/images/station-logos/espnbl.png",
					"name": "ESPN Bases Loaded",
				}, {
					"img": "https://sc.dish.com/shared/images/station-logos/outsd.png",
					"name": "Outside TV",
				}, {
					"img": "https://sc.dish.com/shared/images/station-logos/olymp.png",
					"name": "Olympic Channel",
				}, {
					"img": "https://sc.dish.com/shared/images/station-logos/attpt.png",
					"name": "AT&T SportsNet Pittsburgh",
				}, {
					"img": "https://sc.dish.com/shared/images/station-logos/attrm.png",
					"name": "AT&T SportsNet Rocky Mountain",
				}, {
					"img": "https://sc.dish.com/shared/images/station-logos/rtnw.png",
					"name": "Root Sports Northwest",
				}, {
					"img": "https://sc.dish.com/shared/images/station-logos/nbsch.png",
					"name": "NBC Sports Chicago",
				}, {
					"img": "https://sc.dish.com/shared/images/station-logos/nbswa.png",
					"name": "NBC Sports Washington",
				}, {
					"img": "https://sc.dish.com/shared/images/station-logos/nbsca.png",
					"name": "NBC Sports California",
				}, {
					"img": "https://sc.dish.com/shared/images/station-logos/nbsba.png",
					"name": "NBC Sports Bay Area",
				}],

				flickityOptions: {
					groupCells: true,
					pageDots: false,
					watchCSS: true,
				},

				guideForm: {
					email: '',
					invalidEmail: false,
				},

				phoneNumber: '1-800-811-4191',
				offerActive: new Date() < new Date(1588568399000), // Sun May 03 2020 23:59:59 GMT-0500 (Central Daylight Time)

				popup: {
					email: '',
					first: '',
					last: '',

					invalidEmail: '',

					open: false,
					showForm: false,
				},
			}
		},

		methods: {
			fitImage() {
				objectFitImages(this.$refs['image'])
			},

			submitForm(submit) {
				if (!emailRegex.test(this.guideForm.email)) {
					this.guideForm.invalidEmail = true
					return
				}

				submit([
					{ name: 'email', value: this.guideForm.email },
				])
			},

			submitPopup(submit) {
				if (!emailRegex.test(this.popup.email)) {
					this.popup.invalidEmail = true
					return
				}

				submit([
					{ name: 'firstname', value: this.popup.first },
					{ name: 'lastname', value: this.popup.last },
					{ name: 'email', value: this.popup.email },
				])
			},
		},

		mounted() {
			setTimeout(() => {
				this.popup.open = true
			}, 5000)
		},

		watch: {
			guideForm: {
				email() {
					if (this.guideForm.invalidEmail) {
						this.guideForm.invalidEmail = !emailRegex.test(this.guideForm.email)
					}
				},
			},

			popup: {
				email() {
					if (this.popup.invalidEmail) {
						this.popup.invalidEmail = !emailRegex.test(this.popup.email)
					}
				},
			},
		},
	}
</script>

<style src="channel-boxes/lib/channel-boxes.css"/>

<style scoped>
	.object-cover.object-center {
		@apply object-cover object-center;
	}

	.transitions {
		transition: opacity .5s ease-in-out;
	}

	.tabular-nums {
		font-variant-numeric: tabular-nums;
	}

	.price::before {
		content: '$';
		font-size: .5em;
		vertical-align: super;
	}

	input::placeholder {
		@apply text-gray-600;
	}

	.submitting {
		@apply text-transparent relative !important;
	}

	.submitting::after {
		@apply absolute border-4 w-6 h-6 rounded-full !important;

		content: ' ' !important;
		left: calc(50% - .75rem) !important;
		top: calc(50% - .75rem) !important;
		border-color: #ffffff44 !important;
		border-top-color: #ffffff !important;
		animation: spinning 1.5s ease-in-out 0s infinite !important;
	}

	@keyframes spinning {
		from {
			transform: rotate(0deg);
		}

		to {
			transform: rotate(720deg);
		}
	}

	.antennas-flickity::after {
		content: 'flickity';
		display: none;
	}

	@screen lg {
		.antennas-flickity::after {
			content: '';
		}
	}
</style>
